<template>
  <move-template :automatic="automatic" :order-type="orderType" :type="type"/>
</template>

<script>
import MoveTemplate from '@/views/operation/movebound/MoveTemplate.vue'

export default {
  name: 'AutomaticMoveOrder',
  components: { MoveTemplate },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      type: 'movementTransfer',
      orderType: { id: this.queryParam.value.business.orderTypeId },
      automatic: true
    }
  },
  methods: {}
}
</script>